module.exports = __webpack_public_path__ + "static/media/avatar.2741b24d.png";